import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Navigate } from 'react-router-dom';
/**
 * react-router-dom Navigate ラップコンポーネント
 * https://reactrouter.com/en/main/components/navigate
 * エラーメッセージの表示やリダイレクト先の保存などを行う可能性があるものは CustomRedirect を使用する
 */
export const CustomNavigate = (props) => {
    const { replace, state, to } = props;
    return _jsx(Navigate, { replace: replace, state: state, to: to });
};
